export default __webpack_public_path__ + "static/media/newClass.2548bda9.png";